
import { cn } from "../lib/utils";

function Optimization( { className, ...props } ) {

  return (

    <div

      className={ cn( "flex flex-col sm:flex-row gap-4 md:gap-8 items-center", className ) }
      
      { ...props }

    />

  )

}

function OptimizationContent( { className, ...props } ) {

  return (

    <div

      className={ cn( "flex flex-col gap-0.5", className ) }

      { ...props }

    />

  )

}

function OptimizationHeader( { className, ...props } ) {
  
  return (

    <h3

      className={ cn( "font-bold text-xl text-black", className ) }

      { ...props }

    />

  )

}

function OptimizationNumber( { className, ...props } ) {

  return (

    <span 

      className={ cn( "font-bold text-6xl text-blue-primary", className ) }
      
      { ...props } 
        
    />

  )

}

function OptimizationSubheader( { className, ...props } ) {

  return (

    <p

      className={ cn( "text-black leading-[1.25]", className ) }

      { ...props }

    />

  )

}


export {

  Optimization,

  OptimizationContent,
  
  OptimizationHeader,

  OptimizationNumber,
  
  OptimizationSubheader,
  
}
